import {Action, combineReducers} from '@ngrx/store';
import {cloudinaryReducer} from './posts.reducer';


export const Reducers = combineReducers({
    cloudinary: cloudinaryReducer
})